import { render, staticRenderFns } from "./MainCategoryTabs.vue?vue&type=template&id=5e140d2b&scoped=true"
import script from "./MainCategoryTabs.vue?vue&type=script&lang=js"
export * from "./MainCategoryTabs.vue?vue&type=script&lang=js"
import style0 from "./MainCategoryTabs.vue?vue&type=style&index=0&id=5e140d2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e140d2b",
  null
  
)

export default component.exports